import {LOCO_TYPE} from "../../constants/Constants";
import Order from "./Order";
import {SecurityGameCard, SecurityGameCardEffect} from "./cards/SecurityGameCard";
import PathGameCard from "./cards/PathGameCard";
import StationGameCard from "./cards/StationGameCard";
import LocoGameCard from "./cards/LocoGameCard";

export const GetSecurityLevelCost = () => {
    return 20000000;
}
export const GetSecurityExpanses = (level) => {
    switch (level) {
        default:
        case 1:
            return 5000000;
        case 2:
            return 8000000;
        case 3:
            return 10000000;
        case 4:
            return 15000000;
        case 5:
            return 20000000;
    }
}
export const GetSparePartCost = (isInvest = false) => {
    return isInvest ? 1000000 : 2000000;
}
export const GetBrigadeCost = (isInvest = false) => {
    return isInvest ? 1000000 : 3000000;
}
export const GetBrigadeSalary = () => {
    return 7000000;
}
export const GetLocoCost = (type) => {
    switch (type) {
        default:
            return 100000000;
        case LOCO_TYPE:
            return 80000000;
    }
}

export const DAYS_IN_YEAR = 2;
export const GetBrigadesChips = (type) => {
    switch (type) {
        default:
        case "station":
        case "repair":
        case "dispetcher":
            return 4;
        case "loco":
            return 1;
    }
}

export const GetPathLength = (pathId) => {

    switch (pathId) {
        default:
        case 1:
        case 2:
            return 720;
        case 3:
        case 4:
            return 1000;
        case 5:
            return 600;
        case 6:
        case 7:
            return 840;
    }
}
export const GetTrainCarWeight = type => {
    return (CargoWeight(type) - CargoWeight('empty'));
}
const defaultPackTypes = [
    "coal",
    "prod",
    "containerWithCargo",
    "containerEmpty",
    "cement"
];
export const IsPackOther = (type) => {
    return !defaultPackTypes.includes(type) && type !== 'empty';
}
export const RepairValue = 10;
export const RepairStagesCount = 4;
export const MaxSecurityLevel = 5;
export const Variables = {
    "trainCarWeight": 20,
    "trainCarWithCargoWeight": 70,
    "trainCarLiftingCapacity": 50,
    "containerWeight": 5,
    "containerWithCargoWeight": 20,
    "containerLiftingCapacity": 15,
    "electroLocoWeight": 80,
    "LocoWeight": 60
}
export const EMPTY_TRAIN_CAR_TYPE = "empty";
export const COAL_TRAIN_CAR_TYPE = "coal";
export const PROD_TRAIN_CAR_TYPE = "prod";
export const CONTAINER_FULL_TRAIN_CAR_TYPE = "containerWithCargo";
export const CONTAINER_EMPTY_TRAIN_CAR_TYPE = "containerEmpty";
export const CHEM_TRAIN_CAR_TYPE = "chem";
export const METAL_TRAIN_CAR_TYPE = "metal";
export const PAPER_TRAIN_CAR_TYPE = "paper";
export const CRAFT_TRAIN_CAR_TYPE = "craft";
export const CEMENT_TRAIN_CAR_TYPE = "cement";

export const CargoWeight = (type) => {
    let defData = {
        "coal": 70,
        "prod": 70,
        "containerWithCargo": 60,
        "containerEmpty": 30,
        "cement": 70,
        "empty": 20
    }
    if (type in defData) {
        return defData[type];
    }
    return 70;
};
export const CargoCosts = {
    "coal": 110,
    "prod": 150,
    "containerWithCargo": 150,
    "containerEmpty": 200,
    "cement": 180,
    "empty": 0
};
export const RepairPlaces = {
    "electro": 4,
    "loco": 2
}
export const LOCO_CARGO_LIFTING_CAPACITY = {
    "electro": 40,
    "loco": 30
}
export const LOCO_EMPTY_LIFTING_CAPACITY = {
    "electro": 70,
    "loco": 40
}
export const LOCO_WEIGHT = {
    "electro": 80,
    "loco": 60
}
export const MAX_TRAIN_LIFTING_CAPACITY = [
    40,
    100
]

export const TRAIN_CAR_CARD_MAX_CARS = 20;
export const DayOrders = [
    [
        new Order("У1", "РОСУГОЛЬ", 2, 3, COAL_TRAIN_CAR_TYPE, 8000)
    ],
    [
        new Order("У2", "РОСУГОЛЬ", 2, 3, COAL_TRAIN_CAR_TYPE, 8000),
        new Order("C2", "АГРОПРОМ", 2, 1, PROD_TRAIN_CAR_TYPE, 4000),
        new Order("К2", "АВТОВАЗ", 1, 0, CONTAINER_FULL_TRAIN_CAR_TYPE, 1600)
    ],
    [
        new Order("У3", "РОСУГОЛЬ", 2, 3, COAL_TRAIN_CAR_TYPE, 8000),
        new Order("Ц3", "ЦЕМЕНТ", 3, 1, CEMENT_TRAIN_CAR_TYPE, 4000)
    ],
    [
        new Order("У4", "РОСУГОЛЬ", 2, 3, COAL_TRAIN_CAR_TYPE, 8000),
        new Order("C4", "АГРОПРОМ", 2, 1, PROD_TRAIN_CAR_TYPE, 4000),
        new Order("К4", "АВТОВАЗ", 1, 0, CONTAINER_FULL_TRAIN_CAR_TYPE, 1600)
    ]
]

export const SecurityCards = [
    new SecurityGameCard(true),
    new SecurityGameCard(true),
    new SecurityGameCard(true),
    new SecurityGameCard(true),
    new SecurityGameCard(true),
    new SecurityGameCard(true),
    new SecurityGameCard(true),
    new SecurityGameCard(true),
    new SecurityGameCard(false, [5], [
        new SecurityGameCardEffect(20000000, 6, 3),
        new SecurityGameCardEffect(20000000, 5, 1),
        new SecurityGameCardEffect(10000000, 3, 1),
        new SecurityGameCardEffect(1000000, 1, 1),
        new SecurityGameCardEffect(0, 0, 0)
    ]),
    new SecurityGameCard(false, [3, 4], [
        new SecurityGameCardEffect(30000000, 6, 3),
        new SecurityGameCardEffect(20000000, 5, 1),
        new SecurityGameCardEffect(10000000, 2, 1),
        new SecurityGameCardEffect(1000000, 1, 1),
        new SecurityGameCardEffect(0, 0, 0)
    ]),
    new SecurityGameCard(false, [1, 2], [
        new SecurityGameCardEffect(10000000, 5, 2),
        new SecurityGameCardEffect(10000000, 4, 2),
        new SecurityGameCardEffect(10000000, 4, 2),
        new SecurityGameCardEffect(10000000, 3, 2),
        new SecurityGameCardEffect(0, 2, 1)
    ]),
    new SecurityGameCard(false, [5], [
        new SecurityGameCardEffect(20000000, 6, 3),
        new SecurityGameCardEffect(15000000, 3, 2),
        new SecurityGameCardEffect(10000000, 3, 1),
        new SecurityGameCardEffect(5000000, 1, 1),
        new SecurityGameCardEffect(0, 0, 0)
    ]),
    new SecurityGameCard(false, [6, 7], [
        new SecurityGameCardEffect(50000000, 8, 8),
        new SecurityGameCardEffect(40000000, 5, 4),
        new SecurityGameCardEffect(40000000, 6, 3),
        new SecurityGameCardEffect(30000000, 5, 2),
        new SecurityGameCardEffect(30000000, 4, 2)
    ]),
    new SecurityGameCard(false, [3, 4], [
        new SecurityGameCardEffect(30000000, 6, 3),
        new SecurityGameCardEffect(20000000, 5, 2),
        new SecurityGameCardEffect(10000000, 2, 2),
        new SecurityGameCardEffect(5000000, 1, 0),
        new SecurityGameCardEffect(0, 0, 0)
    ]),
    new SecurityGameCard(false, [1, 2], [
        new SecurityGameCardEffect(15000000, 5, 3),
        new SecurityGameCardEffect(10000000, 4, 1),
        new SecurityGameCardEffect(10000000, 4, 2),
        new SecurityGameCardEffect(10000000, 4, 2),
        new SecurityGameCardEffect(0, 3, 1)
    ]),
    new SecurityGameCard(false, [6, 7], [
        new SecurityGameCardEffect(50000000, 8, 8),
        new SecurityGameCardEffect(40000000, 7, 6),
        new SecurityGameCardEffect(40000000, 6, 3),
        new SecurityGameCardEffect(30000000, 5, 3),
        new SecurityGameCardEffect(30000000, 4, 2)
    ])
]

export const PathCards = [
    new PathGameCard(true),
    new PathGameCard(true),
    new PathGameCard(false, 1),
    new PathGameCard(false, 2),
    new PathGameCard(false, 3),
    new PathGameCard(false, 4),
    new PathGameCard(false, 5),
    new PathGameCard(false, 6),
    new PathGameCard(false, 7),
];
export const LocoCards = [
    new LocoGameCard(true),
    new LocoGameCard(false, [1, 2], 4),
    new LocoGameCard(false, null, 6),
    new LocoGameCard(false, null, 4),
    new LocoGameCard(false, [1, 2], 6)
]
export const StationCards = [
    new StationGameCard(true),
    new StationGameCard(true),
    new StationGameCard(true),
    new StationGameCard(true),
    new StationGameCard(false, "dispetcher", 0, 2),
    new StationGameCard(false, "station", 0, 2),
    new StationGameCard(false, "station", 0, 2),
    new StationGameCard(false, "station", 1, 4),
    new StationGameCard(false, "station", 3, 2),
    new StationGameCard(false, "repair", 0, 2),
    new StationGameCard(false, "repair", 1, 2),
    new StationGameCard(false, "repair", 2, 2),
];

export const Tenders = [
    {
        id: 1,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 2,

        costPerTonWeight: 50,
        loadDayWeight: [6, 5, 3, 2],
        unloadDayWeight: [1, 6, 5, 4],
        npsWeight: 30,
        expWeight: 4,
        creditWeight: 4,
        order: new Order("АЦТ1", "Альфа цемент", 3, 1, CEMENT_TRAIN_CAR_TYPE, 1700)
    },
    {
        id: 2,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 2,

        costPerTonWeight: 20,
        loadDayWeight: [6, 5, 3, 2],
        unloadDayWeight: [5, 30, 20, 15],
        npsWeight: 6,
        expWeight: 30,
        creditWeight: 8,
        order: new Order("ПТ1", "Пятёрочка", 2, 1, PROD_TRAIN_CAR_TYPE, 1900)
    },
    {
        id: 3,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 3,

        costPerTonWeight: 50,
        loadDayWeight: [6, 5, 3, 2],
        unloadDayWeight: [1, 6, 5, 4],
        npsWeight: 30,
        expWeight: 4,
        creditWeight: 4,
        order: new Order("БТ1", "БЕТОНАР", 1, 3, CONTAINER_FULL_TRAIN_CAR_TYPE, 1600)
    },
    {
        id: 4,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 4,

        costPerTonWeight: 50,
        loadDayWeight: [4, 3, 2, 1],
        unloadDayWeight: [1, 6, 5, 4],
        npsWeight: 6,
        expWeight: 6,
        creditWeight: 30,
        order: new Order("КТ1", "КГОК", 1, 2, CHEM_TRAIN_CAR_TYPE, 1600)
    },
    {
        id: 5,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 1,

        costPerTonWeight: 42,
        loadDayWeight: [22, 18, 14, 10],
        unloadDayWeight: [1, 3, 3, 3],
        npsWeight: 9,
        expWeight: 2,
        creditWeight: 22,
        order: new Order("БКТ1", "БОКСИТОГОРСК", 1, 0, METAL_TRAIN_CAR_TYPE, 3000)
    },
    {
        id: 6,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 2,

        costPerTonWeight: 20,
        loadDayWeight: [6, 5, 3, 2],
        unloadDayWeight: [1, 6, 5, 4],
        npsWeight: 30,
        expWeight: 30,
        creditWeight: 8,
        order: new Order("А1", "АРХАНГЕЛЬСКИЙ ЦБК", 2, 0, PAPER_TRAIN_CAR_TYPE, 1000)
    },
    {
        id: 7,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 1,

        costPerTonWeight: 20,
        loadDayWeight: [4, 3, 2, 1],
        unloadDayWeight: [5, 30, 20, 15],
        npsWeight: 10,
        expWeight: 6,
        creditWeight: 30,
        order: new Order("Л1", "ЛАДЬЯ-ЭКСПО", 0, 2, PAPER_TRAIN_CAR_TYPE, 1200)
    },
    {
        id: 8,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 2,

        costPerTonWeight: 40,
        loadDayWeight: [5, 6, 3, 2],
        unloadDayWeight: [1, 5, 6, 1],
        npsWeight: 15,
        expWeight: 10,
        creditWeight: 23,
        order: new Order("АЦТ1", "Альфа цемент", 3, 1, CEMENT_TRAIN_CAR_TYPE, 1700)
    },
    {
        id: 9,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 2,

        costPerTonWeight: 35,
        loadDayWeight: [4, 3, 5, 2],
        unloadDayWeight: [2, 4, 3, 5],
        npsWeight: 40,
        expWeight: 10,
        creditWeight: 5,
        order: new Order("ПТ1", "Пятёрочка", 2, 1, PROD_TRAIN_CAR_TYPE, 1900)
    },
    {
        id: 10,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 3,

        costPerTonWeight: 35,
        loadDayWeight: [2, 3, 5, 4],
        unloadDayWeight: [5, 10, 15, 25],
        npsWeight: 5,
        expWeight: 22,
        creditWeight: 8,
        order: new Order("БТ1", "БЕТОНАР", 1, 3, CONTAINER_FULL_TRAIN_CAR_TYPE, 1600)
    },
    {
        id: 11,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 4,

        costPerTonWeight: 20,
        loadDayWeight: [6, 15, 3, 12],
        unloadDayWeight: [15, 9, 12, 6],
        npsWeight: 15,
        expWeight: 15,
        creditWeight: 20,
        order: new Order("КТ1", "КГОК", 1, 2, CHEM_TRAIN_CAR_TYPE, 1600)
    },
    {
        id: 12,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 1,

        costPerTonWeight: 50,
        loadDayWeight: [10, 30, 5, 20],
        unloadDayWeight: [4, 3, 5, 2],
        npsWeight: 6,
        expWeight: 6,
        creditWeight: 3,
        order: new Order("БКТ1", "БОКСИТОГОРСК", 1, 0, METAL_TRAIN_CAR_TYPE, 3000)
    },
    {
        id: 13,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 2,

        costPerTonWeight: 40,
        loadDayWeight: [3, 5, 2, 1],
        unloadDayWeight: [4, 3, 5, 2],
        npsWeight: 20,
        expWeight: 20,
        creditWeight: 10,
        order: new Order("А1", "АРХАНГЕЛЬСКИЙ ЦБК", 2, 0, PAPER_TRAIN_CAR_TYPE, 1000)
    },
    {
        id: 14,
        isPlacedOrder: false,
        isMarketResearchBuyed: false,
        repeatPeriod: 1,

        costPerTonWeight: 50,
        loadDayWeight: [5, 3, 4, 1],
        unloadDayWeight: [3, 10, 5, 8],
        npsWeight: 10,
        expWeight: 10,
        creditWeight: 25,
        order: new Order("Л1", "ЛАДЬЯ-ЭКСПО", 0, 2, PAPER_TRAIN_CAR_TYPE, 1200)
    }
]
